import { Helmet } from 'react-helmet';
import { Box, Grid } from '@mui/material';
import StoreProductSales from 'components/Sales/StoreProductSales';
import ProductFilterForm from 'components/product/ProductFilterForm';
import { useState } from 'react';

const ProductList = () => {
  const [filters, setFilters] = useState({
    startDate: new Date(),
    endDate: new Date(),
    stores: [],
    allStores: true,
  });

  const sendDataToParent = (data) => {
    // support both old (sDate,eDate) and new {startDate,endDate,stores,allStores}
    if (data && data.startDate && data.endDate && Array.isArray(data.stores)) {
      setFilters(data);
    } else if (data instanceof Date) {
      // fallback
      setFilters((prev) => ({ ...prev, startDate: data }));
    } else if (Array.isArray(data)) {
      setFilters((prev) => ({ ...prev }));
    } else if (data && data.startDate) {
      setFilters((prev) => ({ ...prev, ...data }));
    }
  };

  return (
    <>
      <Helmet>
        <title> Product sales | Nutriart</title>
      </Helmet>
      <Box pt={2}>
        <Grid item lg={12} md={12} xl={12} xs={12}>
          <ProductFilterForm sendDataToParent={sendDataToParent} />
        </Grid>
        <StoreProductSales
          startDate={filters.startDate}
          endDate={filters.endDate}
          stores={filters.stores}
          allStores={filters.allStores}
        />
      </Box>
    </>
  );
}

export default ProductList;
